import React, { Fragment, useState } from 'react';
import NavigationMegaMenu from './Navigation.MegaMenu';

const Navigation = ({contentLinks: links=[], contentLink=null, onMegaMenuClose, blockElements, onLinkHover, onMouseLeaveLink, activeMegaMenu, blockSectionColumnSize }) => {
    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const selectedClass = contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = link => link.name || (link.links || []).length > 0;

    return links.length > 0 
        ? <ul className="navbar__menu">
            {links.length > 0 && links.map((link, i) => link && hasNameOrChildren(link) &&
                <li className="navbar__item" key={`navbar-link-${link.name}${link.url}${i}`}>
                    <a className={`navbar__link ${selectedClass} ${hasChildrenClass || '' } ${additionClass || ''}`} 
                        onMouseOver={() => onLinkHover(link)}
                        onMouseLeave={onMouseLeaveLink}
                        style={{color: link.nameColor, fontWeight: link.nameBold ? "bold" : null}}
                        href={link.url||'#'} dangerouslySetInnerHTML={{__html: link.name}} >
                    </a>
                    {(link.links.length > 0 || link.blocks.length > 0) &&
                        <NavigationMegaMenu blockSectionColumnSize={link.blockSectionColumnSize} onMegaMenuClose={onMegaMenuClose} onMouseLeaveMegaMenu={onMouseLeaveLink} onMouseOverMegaMenu={() => onLinkHover(link)} contentLink={link} blockElements={blockElements} open={activeMegaMenu == link} />
                    }
                </li>
            )}
        </ul>
        : null;
}

export default Navigation;